import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const SubHeaderContainer = styled.div`
  height: 40px;
  background-color: #f8f9fa;
  padding: 10px;
  padding-left: 20px;
  border-bottom: 1px solid #dee2e6;
`;

const SubHeaderLink = styled(Link)`
  text-decoration: none;
  color: #007bff;
  margin-right: 5px;

  &:hover {
    text-decoration: underline;
  }
`;

const SubHeader = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  return (
    <SubHeaderContainer>
      <SubHeaderLink to="/home">Home</SubHeaderLink>
      {pathSegments.map((segment, index) => {
        const path = `/${pathSegments.slice(0, index + 1).join('/')}`;
        return (
          <React.Fragment key={index}>
            {' / '}
            <SubHeaderLink to={path}>{segment}</SubHeaderLink>
          </React.Fragment>
        );
      })}
    </SubHeaderContainer>
  );
};

export default SubHeader;